/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 04/05/2026.
 */
import { format } from 'date-fns'
import dayjs from 'dayjs'

export const formatDate = (dateStr: string) => {
  if (!dateStr) {
    format(new Date(), 'd MMM yyyy')
  }

  return format(new Date(dateStr), 'd MMM yyyy')
}

export const formatAnswerDateUTC = (dateString: string) => {
  const created = dayjs.utc(dateString).format('DD MMMM YYYY, HH:mm:ss') + ' UTC'
  return `${created}`
}
